import { CoreUIMediaItem } from './core-ui-media.types';

const MEDIA_METADATA_SEPARATOR = ' • ';

const MEDIA_FORMAT_BY_CONTENT_TYPE: Readonly<Record<string, string>> = {
  'application/msword': 'DOC',
  'application/pdf': 'PDF',
  'application/vnd.ms-excel': 'XLS',
  'application/vnd.ms-powerpoint': 'PPT',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'PPTX',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'XLSX',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'DOCX',
  'application/zip': 'ZIP',
  'image/jpeg': 'JPG',
  'image/svg+xml': 'SVG',
  'text/plain': 'TXT',
};

export function coreMediaTypeLabel(item: CoreUIMediaItem): string {
  if (item.type === 'image') return 'Imagen';
  if (item.type === 'video') return 'Video';
  return item.contentType === 'application/pdf' ? 'PDF' : 'Documento';
}

export function coreMediaFormatLabel(item: CoreUIMediaItem): string {
  const extension = item.name.trim().match(/\.([a-z0-9]{1,10})$/i)?.[1];
  if (extension) return extension.toUpperCase();

  const contentType = item.contentType?.split(';', 1)[0].trim().toLowerCase();
  if (contentType && MEDIA_FORMAT_BY_CONTENT_TYPE[contentType]) {
    return MEDIA_FORMAT_BY_CONTENT_TYPE[contentType];
  }

  const subtype = contentType?.split('/', 2)[1];
  if (subtype && /^[a-z0-9-]{1,10}$/i.test(subtype)) return subtype.toUpperCase();
  return coreMediaTypeLabel(item).toUpperCase();
}

export function formatCoreMediaSize(
  size: number | null | undefined,
  locale?: string,
): string {
  if (!size || size < 1) return '';
  const units = ['B', 'KB', 'MB', 'GB'];
  const unitIndex = Math.min(Math.floor(Math.log(size) / Math.log(1024)), units.length - 1);
  const value = size / 1024 ** unitIndex;
  const roundedValue = value >= 10 || unitIndex === 0 ? Math.round(value) : Math.round(value * 10) / 10;
  let formattedValue = String(roundedValue);

  if (locale) {
    formattedValue = new Intl.NumberFormat(locale, { maximumFractionDigits: 1 }).format(roundedValue);
  } else if (unitIndex > 0 && value < 10) {
    formattedValue = roundedValue.toFixed(1);
  }

  return `${formattedValue} ${units[unitIndex]}`;
}

export function coreMediaMetadataLabel(item: CoreUIMediaItem, locale?: string): string {
  return [formatCoreMediaSize(item.size, locale), coreMediaFormatLabel(item)]
    .filter(Boolean)
    .join(MEDIA_METADATA_SEPARATOR);
}

export function coreMediaPreviewMetadataLabel(item: CoreUIMediaItem, locale?: string): string {
  return [coreMediaFormatLabel(item), formatCoreMediaSize(item.size, locale)]
    .filter(Boolean)
    .join(MEDIA_METADATA_SEPARATOR);
}
